module.exports = __webpack_public_path__ + "static/media/coinquora.67e0f9d3.png";